import { render, staticRenderFns } from "./NewAuthentication.vue?vue&type=template&id=182c65ea&"
import script from "./NewAuthentication.vue?vue&type=script&lang=js&"
export * from "./NewAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports